__turbopack_context__.v({
  "entityFade": "LeftNavClient-module__uqHKxa__entityFade",
  "leftNavClient": "LeftNavClient-module__uqHKxa__leftNavClient",
});
